import { z } from "zod";

export const userSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string().min(1).max(100),
  emailVerified: z.boolean().default(false),
  image: z.string().url().nullable().optional(),
  avatarEmoji: z.string().nullable().optional(),
  avatarColor: z.string().nullable().optional(),
  payPayUrl: z.string().url().nullable().optional(),
  lineUserId: z.string().nullable().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type User = z.infer<typeof userSchema>;

export const createUserSchema = userSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  emailVerified: true,
});

export type CreateUser = z.infer<typeof createUserSchema>;

export const updateUserSchema = userSchema
  .omit({
    id: true,
    email: true,
    createdAt: true,
    updatedAt: true,
  })
  .partial();

export type UpdateUser = z.infer<typeof updateUserSchema>;
